import { useCurrency } from "@/lib/currency";

export default function CurrencySwitcher({ compact = false }) {
  const { currency, setCurrency, currencies, symbols } = useCurrency();
  return (
    <div className={`inline-flex items-center rounded-md border border-slate-300 bg-white overflow-hidden ${compact ? "text-xs" : "text-sm"}`} data-testid="currency-switcher">
      {currencies.map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => setCurrency(c)}
          data-testid={`currency-btn-${c}`}
          className={`px-2.5 py-1.5 font-semibold transition-colors ${currency === c ? "bg-[#1a2d5e] text-white" : "text-slate-600 hover:bg-slate-100"}`}
          aria-pressed={currency === c}
        >
          {symbols[c]} {c}
        </button>
      ))}
    </div>
  );
}
